import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext.jsx";
import SEO from "../components/SEO.jsx";
import { seoPresets } from "../seoPresets";

export default function VerifyEmail() {
  const seo = seoPresets["/verify-email"];
  const { verifyEmailToken } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const params = new URLSearchParams(loc.search);
  const token = params.get("token");
  const next = params.get("next") || "/set-password";

  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("");

  useEffect(() => {
    let mounted = true;
    (async () => {
      if (!token) {
        setStatus("error");
        setMessage("Missing verification token.");
        return;
      }
      try {
        await verifyEmailToken(token);
        if (!mounted) return;
        setStatus("ok");
        setTimeout(() => nav(next, { replace: true }), 600);
      } catch (e) {
        if (!mounted) return;
        setStatus("error");
        setMessage(e?.message || "Verification failed.");
      }
    })();
    return () => (mounted = false);
  }, [token, next, nav, verifyEmailToken]);

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        canonical={seo.canonical}
        image={seo.openGraph?.image}
        jsonLd={seo.jsonLd}
        ogType={seo.openGraph?.type || "website"}
        twitterCard={seo.twitter?.card || "summary_large_image"}
        robots="noindex, nofollow"
      />
    <div style={wrap}>
      <div style={card}>
        <h1 style={{ marginTop: 0 }}>Verify your email</h1>
        {status === "verifying" && <p>Checking your link…</p>}
        {status === "ok" && <p>Verified! Redirecting…</p>}
        {status === "error" && (
          <>
            <p style={{ color: "#b00020" }}>{message}</p>
            <p>
              You can close this tab and <Link to="/signup">start again</Link>.
            </p>
          </>
        )}
      </div>
    </div>
    </>
  );
}

const wrap = { minHeight: "100dvh", display: "grid", placeItems: "center", background: "#f7f9fc", padding: 24 };
const card = { width: "100%", maxWidth: 520, background: "#fff", border: "1px solid #e7eaf0", borderRadius: 16, padding: 20, boxShadow: "0 18px 60px rgba(16,24,40,.08)" };
